import userApi from "api/userApi";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { ceil } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { components } from "react-select";
import { AsyncPaginate, wrapMenuList } from "react-select-async-paginate";
import { toast } from "react-toastify";
import NO_IMAGE_USER from "../../assets/images/no-user.png";
import {
  COLOR_RESERVATION_USER_TYPE,
  RESERVATION_USER_TYPE,
} from "helpers/constans";
import { capitalizeFirstLetter } from "utils";

interface Option {
  label: string | any;
  value: string;
}
interface DropdownOptionProps {
  name?: string;
  listCheckedUsers?: string | null;
  debounceTimeout?: number;
  onChangeSelect?: (params: Option) => void;
  isMulti?: boolean;
  placeholder?: string;
  isShowIconCheck?: boolean;
  hideSelectedOptions?: boolean;
  isAllOption?: boolean;
  isDisabled?: boolean;
  defaultParams?: any;
  isClearable?: boolean;
  isShowAvatar?: boolean;
  isShowOnManualPush?: boolean;
}
const LIMIT = 30;

export const GetLabelUserDropdown = ({ itemUser }: { itemUser: any }) => {
  const { t } = useTranslation();
  let platform = itemUser?.provider;
  let lowTextPlatform = platform ? platform.toLowerCase() : "";

  let userType = itemUser?.type;
  let avatar = itemUser?.profile?.imageUrls?.[0];
  let name = itemUser?.profile?.nickname;
  let email = itemUser?.profile?.email;
  if (userType === "MANAGER") {
    avatar = itemUser?.store?.thumbnailUrl;
    name = itemUser?.store?.managerName;
    email = itemUser?.store?.managerEmail;
  }

  return (
    <div className="d-flex align-items-center gap-2">
      <div
        style={{
          height: "30px",
          width: "30px",
          minWidth: "30px",
          overflow: "hidden",
          borderRadius: "15px",
          objectFit: "cover",
          backgroundColor: "#eaeaea",
          zIndex: 99,
        }}
      >
        <img
          src={avatar || NO_IMAGE_USER}
          alt={itemUser?.profile?.nickname}
          height={30}
          width={30}
          style={{
            minWidth: "30px",
            overflow: "hidden",
            borderRadius: "50%",
            objectFit: "cover",
            backgroundColor: "#eaeaea",
          }}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = NO_IMAGE_USER;
          }}
        />
      </div>

      <div>
        <span
          className={`rounded-pill badge bg-${
            COLOR_RESERVATION_USER_TYPE[userType] || "secondary"
          }`}
        >
          {t(
            RESERVATION_USER_TYPE?.find(
              (item: any) => String(item?.value) === String(userType)
            )?.label || ""
          )}
        </span>

        <div className="d-flex flex-column">
          {userType === "MANAGER" ? (
            !itemUser?.store ? (
              <>
                {itemUser?.email ? (
                  <div>
                    <small>{t("Email SNS")}:</small> {itemUser?.email}
                  </div>
                ) : (
                  <>
                    <div className="cursor-pointer">
                      <small>
                        {t(
                          capitalizeFirstLetter(
                            lowTextPlatform === "default" ||
                              lowTextPlatform == "guest"
                              ? "Email"
                              : lowTextPlatform
                          )
                        )}
                        :
                      </small>{" "}
                      {itemUser?.providerId}
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div>{[name, email].filter(Boolean).join(" - ")}</div>
                <div>
                  {itemUser?.store?.name} {" - "}
                  <small className="text-secondary">
                    {itemUser?.storeBusiness?.businessNumber}
                  </small>
                </div>
                <small className="text-secondary">
                  {itemUser?.store?.address?.shortAddress}
                </small>
              </>
            )
          ) : !itemUser?.profile ? (
            <>
              {itemUser?.email ? (
                <div>
                  <small>{t("Email SNS")}:</small> {itemUser?.email}
                </div>
              ) : (
                <div className="cursor-pointer">
                  <small>
                    {t(
                      capitalizeFirstLetter(
                        lowTextPlatform === "default" ||
                          lowTextPlatform == "guest"
                          ? "Email"
                          : lowTextPlatform
                      )
                    )}
                    :
                  </small>{" "}
                  {itemUser?.providerId}
                </div>
              )}
            </>
          ) : (
            [name, email].filter(Boolean).join(" - ")
          )}
        </div>
      </div>
    </div>
  );
};

const DropdownAsyncUsers = ({
  name = "",
  listCheckedUsers,
  debounceTimeout = 700,
  onChangeSelect,
  isMulti = false,
  placeholder,
  isShowIconCheck = false,
  hideSelectedOptions = true,
  isAllOption = false,
  isDisabled = false,
  defaultParams = {},
  isClearable = true,
  isShowAvatar = false,
  isShowOnManualPush = false,
}: DropdownOptionProps) => {
  const { t, i18n } = useTranslation();
  // const [isAllCheckedUsers, setIsAllCheckedUsers] = useState(false);

  const OPTION_ALL_DEFAULT = { label: t("All Filter"), value: "all" };

  const [options, setOptions] = useState([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  const loadListUsers = async ({
    page,
    limit,
    search,
  }: {
    page: number;
    limit: number;
    search?: string;
  }) => {
    try {
      let params: any = {
        page,
        limit,
        keyword: search,
        ...defaultParams,
      };

      const {
        data: { items, pagination },
        code,
      } = await userApi.users(params);

      if (!code) {
        return { success: false };
      }

      let filterData = items;

      // if (defaultParams?.type == "MANAGER") {
      //   filterData = items?.filter((item: any) => {
      //     if (item?.store?.id) {
      //       return item;
      //     }
      //   })
      // }

      const dataUsersOptions = filterData?.map((a: any) => {
        return {
          value: a?.id,
          label: <GetLabelUserDropdown itemUser={a} />,
          data: a,
        };
      });

      return {
        code,
        dataUsersOptions: dataUsersOptions || [],
        lastPage: ceil(pagination?.total / pagination?.limit),
      };
    } catch (err) {
      return {
        code: 404,
        dataUsersOptions: [],
        lastPage: 1,
      };
    }
  };

  async function loadOptions(
    search: string,
    loadedOptions: any[],
    { page }: { page: number }
  ) {
    const { code, dataUsersOptions, lastPage } = await loadListUsers({
      page,
      limit: LIMIT,
      search,
    });
    let dataUsersOptionsFormat = dataUsersOptions || [];

    if (code !== 200) {
      toast(`${t("Failed to load data")}`, CONFIG_OPTION_TOAST_ERROR);
      return {
        options: [],
        hasMore: false,
      };
    }

    let lastPageFormat = lastPage ? lastPage : 1;
    let options = dataUsersOptionsFormat;

    setOptions(options);

    return {
      options: options,
      hasMore: lastPageFormat > page,
      additional: {
        page: page + 1,
      },
    };
  }

  const MenuList = (props: any) => {
    let childComponent = props?.children;
    if (props?.children?.length > 0) {
      const allOption = props?.children?.filter(
        (item: any) => item?.props?.value === OPTION_ALL_DEFAULT?.value
      );
      let fixedIndex = -1;
      if (allOption) {
        fixedIndex = props?.children.indexOf(allOption?.[0]);
      }
      const fixedElement = props?.children?.[fixedIndex];

      const childComponentFormat = (
        (fixedIndex != -1 ? props?.children.slice(1) : props?.children) || []
      )?.sort((a: any, b: any) => {
        let pointA = a.props.isSelected === true ? 1 : 0;
        let pointB = b.props.isSelected === true ? 1 : 0;
        return pointB - pointA;
      });

      if (fixedElement) {
        childComponent = [fixedElement, ...childComponentFormat];
      } else {
        childComponent = childComponentFormat;
      }
    }

    return (
      <components.MenuList {...props}>{childComponent}</components.MenuList>
    );
  };

  let isAllCheckedUsers = false;
  const OptionFormat = (props: any) => {
    if (props?.isSelected && props?.value === OPTION_ALL_DEFAULT?.value) {
      // setIsAllCheckedUsers(true);
      isAllCheckedUsers = true;
    } else if (
      !props?.isSelected &&
      props?.value === OPTION_ALL_DEFAULT?.value
    ) {
      // setIsAllCheckedUsers(false);
      isAllCheckedUsers = false;
    }

    return (
      <components.Option {...props} style={{ zIndex: 999 }}>
        <div className="d-flex align-items-center gap-2">
          {(props?.isSelected || isAllCheckedUsers) && isShowIconCheck ? (
            <i className="ri-check-line align-middle fs-14" />
          ) : (
            ""
          )}
          {props.data?.label}
        </div>
      </components.Option>
    );
  };

  const MenuListAsync = wrapMenuList(MenuList);

  const optionsMemo = useMemo(() => {
    return [...(isAllOption ? [OPTION_ALL_DEFAULT] : []), ...options];
  }, [JSON.stringify(options), isAllOption, i18n?.language]);

  useEffect(() => {
    if (
      ((listCheckedUsers as any)?.value === OPTION_ALL_DEFAULT?.value ||
        !(listCheckedUsers as any)?.value) &&
      isAllOption
    ) {
      setOnChangeOption(OPTION_ALL_DEFAULT);
    }
  }, [i18n.language, isAllOption, JSON.stringify(listCheckedUsers)]);

  return (
    <AsyncPaginate
      key={i18n.language}
      name={name}
      isMulti={isMulti}
      isClearable={isClearable}
      // defaultOptions
      options={optionsMemo}
      debounceTimeout={debounceTimeout}
      value={listCheckedUsers}
      loadOptions={loadOptions}
      placeholder={placeholder}
      className="dropdown-status-rounded"
      hideSelectedOptions={false}
      onChange={(e: any) => setOnChangeOption(e)}
      additional={{
        page: 1,
      }}
      components={{
        Option: OptionFormat,
        ...(isMulti ? { MenuList: MenuListAsync } : null),
        // MenuList: MenuListAsync,
      }}
      closeMenuOnSelect={hideSelectedOptions}
      menuPortalTarget={document.body}
      styles={{
        option: (styles: any) => {
          let styleNew = isMulti
            ? {
                ...styles,
                backgroundColor: "white",
                zIndex: 99,
                color: "black",
              }
            : styles;

          return styleNew;
        },
        control: (styles: any, { isFocused }: any) => {
          return {
            ...styles,
            borderColor: "#e9ebec",
            borderRadius: "0.6rem",
            color: "white",
            "&:hover": { borderColor: "#009ef7" },
          };
        },
        multiValue: (styles: any) => {
          return {
            ...styles,
            backgroundColor: "#009ef7",
          };
        },
        multiValueLabel: (styles: any) => ({
          ...styles,
          color: "white !important",
        }),
        menuPortal: (base: any) => ({
          ...base,
          zIndex: 1051,
        }),
      }}
      isDisabled={isDisabled}
    />
  );
};

export default DropdownAsyncUsers;
